import * as Ariakit from '@ariakit/react'
import * as React from 'react'

import { PlacementId } from '../../../../../containers/EmbroideryContainer/combination-rules/placementIds'

import { placementName, priceSuffix, statusSuffix } from './placementLabels'
import {
  PlacementCardHeaderButton,
  PlacementCardShell,
  PlacementLabel,
  PlacementStatus,
} from './styles'

export type PlacementOptionProps = {
  placementId: PlacementId
  priceLabel?: string
  statusLabel?: string
  isSelected: boolean
  disabled?: boolean
  invalid?: boolean
  onSelect(placementId: PlacementId): void
}

/**
 * One placement in a single-select picker
 */
export const PlacementOption: React.FC<PlacementOptionProps> = ({
  placementId,
  priceLabel,
  statusLabel,
  isSelected,
  disabled = false,
  invalid = false,
  onSelect,
}) => {
  const name = placementName(placementId)

  return (
    <PlacementCardShell $selected={isSelected && !disabled} $disabled={disabled} $invalid={invalid}>
      <Ariakit.Radio
        accessibleWhenDisabled
        disabled={disabled}
        value={placementId}
        onChange={() => onSelect(placementId)}
        render={
          <PlacementCardHeaderButton type='button'>
            <span>
              <PlacementLabel $disabled={disabled}>
                {name}
                {priceSuffix(priceLabel)}
              </PlacementLabel>
              {statusLabel !== undefined && (
                <PlacementStatus>{statusSuffix(statusLabel)}</PlacementStatus>
              )}
            </span>
          </PlacementCardHeaderButton>
        }
      />
    </PlacementCardShell>
  )
}
